var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1ActionForwardArrowB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 33V23a20 20 0 100 40v4a24 24 0 010-48V9l12 12-12 12z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Action_forward_arrow_B.057c859c.svg";
export { SvgJ1ActionForwardArrowB as ReactComponent };